import { render } from "./FamilyCreator.vue?vue&type=template&id=43666320&scoped=true"
import script from "./FamilyCreator.vue?vue&type=script&lang=js"
export * from "./FamilyCreator.vue?vue&type=script&lang=js"

import "./FamilyCreator.vue?vue&type=style&index=0&id=43666320&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43666320"]])

export default __exports__